'use client';

import { ProgressProvider } from '@bprogress/next/app';
import type { ReactElement, ReactNode } from 'react';

type ProvidersProps = {
  children: ReactNode;
};

export const Providers = ({ children }: ProvidersProps): ReactElement => (
  <ProgressProvider color="var(--jaaq-accent)" height="3px" options={{ showSpinner: false }}>
    {children}
  </ProgressProvider>
);
